export enum InvestmentsGradientEnum {
  StoneGreen = 'linear-gradient(90deg, rgba(189, 251, 79, 0.984) 0%, #6CE24D 30%, #BDFB4F 70%, #FFF 100%)',
  StoneGreenHighlight = 'radial-gradient(circle at 0% 100%, rgba(151, 247, 54, 0.4) 0%, rgba(154, 247, 54, 0.4) 54%, rgba(0, 220, 137, 0.4) 100%), linear-gradient(105deg, #00DC89 0%, #97F736 31%, #00DC89 70%, #97F736 82%)'
}
